import { HttpClient } from '@angular/common/http';
import { ErrorHandler, inject } from '@angular/core';
import { DefaultDataService, HttpMethods, HttpUrlGenerator } from '@ngrx/data';
import { catchError, Observable, throwError } from 'rxjs';
import { EntityInterface } from './entity.interface';

export class CustomDefaultDataService<
  T extends EntityInterface,
> extends DefaultDataService<T> {
  private readonly errorHandler = inject(ErrorHandler);

  constructor(
    entityName: string,
    http: HttpClient,
    httpUrlGenerator: HttpUrlGenerator,
  ) {
    super(entityName, http, httpUrlGenerator);
  }

  protected override execute(
    method: HttpMethods,
    url: string,
    data?: any,
    options?: any,
  ): Observable<any> {
    return super.execute(method, url, data, options).pipe(
      catchError((error) => {
        // Передаем ошибку в кастомный ErrorHandler
        this.errorHandler.handleError(error);
        // Возвращаем ошибку дальше, если нужно
        return throwError(() => error);
      }),
    );
  }
}
